import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { makeStyles, Typography } from '@material-ui/core';

import { StepContext } from 'common/createContext/stepContext';

import messages from 'common/messages/messages';
import { Button } from 'common/components';

interface IProps {
  reportId: string;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  actionButton: {
    padding: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
}));

const LinkToReportStep = ({ reportId, onClose }: IProps): JSX.Element => {
  const navigate = useNavigate();
  const classes = useStyles();

  const { onBack, renderFooter, onNext } = useContext(StepContext);

  return (
    <>
      <Button
        variant="text"
        size="small"
        className={classes?.actionButton}
        onClick={() => {
          navigate(`/reports/z-out/${reportId}`);
          onClose();
        }}
      >
        <Typography color="primary" component="span">
          <FormattedMessage {...messages.linkToReportTitle} />
        </Typography>
      </Button>

      {renderFooter ? renderFooter(onBack, onNext) : null}
    </>
  );
};

export default LinkToReportStep;
